import keyBy from 'lodash/keyBy';

export default function remove(
    action: RemoveFolderAction,
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>
) {
    const data = Array.isArray(action.data) ? action.data : [action.data];

    setFolders((latestFolders) => archiveFolder(latestFolders, data));

    return data.map((folder) => folder.localId!);
}

export function archiveFolder(folders: {[localId: string]: Folder}, folderData: Folder[]) {
    const data = folderData.map((folder) => ({
        ...(folders[folder.localId] || folder),
        archived: true,
    }));

    return {
        ...folders,
        ...keyBy(data, (folder) => folder.localId!),
    };
}
